var render, staticRenderFns
import script from "./CrtHeader.vue?vue&type=script&lang=js&"
export * from "./CrtHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08cd9096')) {
      api.createRecord('08cd9096', component.options)
    } else {
      api.reload('08cd9096', component.options)
    }
    
  }
}
component.options.__file = "src/components/layout/Header/CrtHeader.vue"
export default component.exports